export default __webpack_public_path__ + "static/media/insumos-disabled.20cd2bcc.svg";